import clsx from "clsx";
import { ElementType } from "react";
import { ButtonProps as PrimitiveButtonProps, Button as PrimitiveButton, Spinner } from "react-bootstrap";

type ButtonProps = PrimitiveButtonProps & {
    label?: string;
    icon?: string;
    isLoading?: boolean;
    iconRight?: boolean;
    as?: ElementType;
}

export default function Button({ children, iconRight = false, label, isLoading = false, disabled = false, icon, ...props }: ButtonProps) {
    return <PrimitiveButton disabled={
        isLoading || disabled
    } {...props}>
        {!iconRight && (!!icon && !isLoading) && <i className={clsx(`bi ${icon}`, (label || children) &&  'me-2')}></i>}
        {isLoading && (
            <>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-3"
                />
                <span className="visually-hidden">Carregando...</span>
            </>
        )}
        {label ?? children}
        {iconRight && (!!icon && !isLoading) && <i className={clsx(`bi ${icon}`, (label || children) && 'ms-2')}></i>}
    </PrimitiveButton>;
}